import { isDirty, isValid, getFormValues } from 'redux-form';

// combines all redux forms currently into the store into a map by name
export const getReduxFormValues = state =>
  Object.keys(state.form).reduce((result, formName) => ({
    ...result,
    [formName]: getFormValues(formName)(state),
  }), {});

// returns a validation object matching the old style for a given form name
export const getValidationForReduxForm = (state, formName) => ({
  touched: isDirty(formName)(state),
  isValid: isValid(formName)(state),
});



// WEBPACK FOOTER //
// ./src/selectors/reduxForm.js